// extracted by mini-css-extract-plugin
export default {"aboutPolldockPage_h1":"AboutPolldockPage_aboutPolldockPage_h1__d5yTf","aboutPolldockPage_underline":"AboutPolldockPage_aboutPolldockPage_underline__STySm"};